import { render, staticRenderFns } from "./RankingTable.vue?vue&type=template&id=ba11a1e0&scoped=true&"
import script from "./RankingTable.vue?vue&type=script&lang=js&"
export * from "./RankingTable.vue?vue&type=script&lang=js&"
import style0 from "./RankingTable.vue?vue&type=style&index=0&id=ba11a1e0&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba11a1e0",
  null
  
)

export default component.exports